import React, { useContext, useEffect, useRef, useState } from "react";
import { raisePostRequest, raiseDeleteRequest, getCarts, getCartViewItems, getCartsValue, removeCrackersFromCart, clearCartItemsUtil, addCrackersIntoCart } from "../AxiosAPI";
import { Col, Collapse, Row, Form, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { isXSmScreen, isSmScreen, isMdScreen, numericInputOnly } from "../CrackersUtil";
import { CrackersContext } from "../CrackersContext";

import incr from '../images/incr.jpg';
import decr from '../images/decr.jpg';
import ConfirmPopUp from "./ConfirmPopUp";
import LoadingSpinner, { LoadingBorder } from "./LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { Axios } from "axios";
import { width } from "@fortawesome/free-solid-svg-icons/fa0";


function CartView() {
    const [needRefresh, setNeedRefresh] = useState(false);
    const [carts, setCarts] = useState([]);
    const [cartsAmount, setCartsAmount] = useState([]);
    const [emptyCarts, setEmptyCarts] = useState([]);
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [isMobileView, setIsMobileView] = useState(false);
    const [cartsList, setCartsList] = useState([{}]);
    const {serviceCommonData, setShowErrorToastStatus, setToastBody, userInfo, browserCart, setIsZeroCasePage} = useContext(CrackersContext);
    const navigate = useNavigate();
    const [cartCollapse, setCartCollapse] = useState({});

    const [noOfItems, setNoOfItems] = useState(0);
    const [noOfQtys, setNoOfQtys] = useState(0);
    const [parcelCharges, setParcelCharges] = useState(0);
    const [cartsValue, setCartsValue] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [splDiscount, setSplDiscount] = useState(0);
    const [tAmount, setTAmount] = useState(0);
    const [isEligibleToCheckOut, setIsEligibleToCheckOut] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const cartsView = async () => {
            const ctViewData = await getCartViewItems(userInfo, browserCart, null, setShowErrorToastStatus, setToastBody);
            if(!ctViewData) {
                return;
            }
            console.log(JSON.stringify(ctViewData));
            const ctAmount = await getCartsValue(userInfo, ctViewData, serviceCommonData.default_agent_id, null, setShowErrorToastStatus, setToastBody);
            const cartsList = await getCarts(userInfo, setShowErrorToastStatus, setToastBody, browserCart);
            var ctList = [], emptyCtList = [];
            for(let i=0; i<cartsList.length; i++) {
                emptyCtList.push(cartsList[i].name);
            }
            
            var ctData = {}, cartCollapseState = {};
            var numberOfItems = 0, numberOfQty = 0, ctValue = 0;
            if(ctViewData) {
                for(let i=0; i<ctViewData.length; i++) {
                    const cartData = ctViewData[i];
                    var cartName = cartData.cart_name;
                    ctList.push(cartName);
                    if(cartData.data && cartData.data.length > 0) {
                        const index = emptyCtList.indexOf(cartName);
                        if(index > -1) {
                            emptyCtList.splice(index, 1);
                        }
                        cartCollapseState[cartName] = true;
                        ctData[cartName] = [];
                        for(let j=0; j<cartData.data.length; j++) {
                            var ctCrackers = cartData.data[j];
                            var agentName = ctCrackers.agent_name;
                            var crackersList = {"agent_name" : agentName};
                            // var crackers = [];
                            for(let k=0; k<ctCrackers.crackers.length; k++) {
                                if(ctCrackers.crackers[k].stock_status === 1) {
                                    numberOfItems++;
                                    numberOfQty += ctCrackers.crackers[k].order_quantity;
                                    ctValue += ctCrackers.crackers[k].order_price;
                                }
                            }
                            // crackersList["crackers"] = crackers;
                            ctData[cartName].push(ctCrackers);
                        }
                        
                    } 
                    // else {
                    //     emptyCtList.push(cartName);
                    //     cartCollapseState[cartName] = false;
                    // } 
                }    
            }
            setNoOfItems(numberOfItems);
            setNoOfQtys(numberOfQty);
            setCartsValue(ctValue);
            setParcelCharges(100);
            setDiscount(100);
            setSplDiscount(200);
            setTAmount(ctValue);
            if(ctValue >= 2500) {
                setIsEligibleToCheckOut(true);
            } else {
                setIsEligibleToCheckOut(false);
            }
            if(emptyCtList.length > 0) {
                for(let i=0; i<emptyCtList.length; i++) {
                    cartCollapseState[emptyCtList[i]] = false;
                }
            }
            setCartsList(ctData);
            if(userInfo && userInfo.authenticated) { 
                setCarts(ctList);
                if(ctList.length > 0) {
                    setIsZeroCasePage(false);
                } else {
                    setIsZeroCasePage(true);
                }
            } else {
                if(ctData["Default"][0].crackers.length > 0) {
                    setCarts(["Default"]);
                    setIsZeroCasePage(false);
                } else {
                    setCarts([]);
                    setIsZeroCasePage(true);
                }
            }
            setEmptyCarts(emptyCtList);
            setCartCollapse(cartCollapseState);
        }
        cartsView();
        setCartCollapse({ "default": true, "first": true });
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
            setIsMobileView(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth));
        };
        setIsMobileView(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth));

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [needRefresh]);

    const toggleCartCollapse = (cart) => {
        setCartCollapse((prevState) => ({
            ...prevState,
            [cart]: !prevState[cart],
        }));
    };

    const proceedToCheckOut = async () => {
        debugger
        if(isEligibleToCheckOut) {
            debugger
            const status = await raisePostRequest(`/carts/check-out`, null, setLoading, setShowErrorToastStatus, setToastBody);
            if(status && status.status === 'success') {
                // const cartAmount = status.cart_amount;
                navigate("/web/checkout");
            }
        }
    }

    return (
        <div>
            {
                isMobileView ? (
                    <div>
                        {
                            tAmount > 0 ? (
                                <div style={{height : "auto", background : "lightgrey", borderRadius : "12px", position:'sticky', top : "14%", zIndex : "100"}}>
                                    <div style={{padding : "10px", display : "flex", flexDirection : "column", gap: "1px" }}>
                                        <span style={{fontSize : "16px"}}>{`Total items: ${noOfItems} (${noOfQtys} - Quantities)`}</span>
                                        <span style={{fontSize : "16px"}}>{`Cart Value: ₹${cartsValue}`}</span>
                                        <span style={{fontSize : "14px"}}>{`Parcel charges: ₹${parcelCharges}`}</span>
                                        <span style={{fontSize : "14px"}}>{`Discount: ₹${discount}`}</span>
                                        <span style={{fontSize : "14px"}}>{`Special Discount: ₹${splDiscount}`}</span>
                                        <h6>{`Total Amount: ₹${tAmount - 200}`}</h6>
                                        <div style={{display: "flex", justifyContent: "space-between", gap: "1px"}}>
                                            <Button className="ct-vw-cko-btn" variant="primary" style={{ cursor: 'pointer', width : "50%"}} onClick={(e) => navigate("/web/crackers")}>Continue Shopping</Button>
                                            {
                                                (isEligibleToCheckOut) ? (
                                                    <Button className="ct-vw-cko-btn" variant="warning" style={{ cursor: 'pointer', width : "50%"}} onClick={proceedToCheckOut} disabled={!isEligibleToCheckOut}>
                                                        Proceed to Buy
                                                    </Button>
                                                ) : (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    Minimum order amount is ₹2300. Please add more items to proceed.
                                                                </Tooltip>
                                                            }>
                                                            <span className="d-inline-block">
                                                                <Button className="ct-vw-cko-btn" variant="warning" disabled style={{ pointerEvents: 'none' }}>Proceed to Buy</Button>
                                                            </span>
                                                        </OverlayTrigger>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                null
                            )   
                        }
                        <div className="ct-vw-mob-cnt">
                            { 
                                carts.length > 0 ? (
                                carts.map((cart, index) => (
                                    <div key={cart}>
                                        <div className="ct-vw" style={{zIndex : "-100"}}>
                                        <div>
                                            <h3 className="ct-vw-ttle" onClick={() => toggleCartCollapse(cart)} aria-controls={`collapse-${cart}-cart`} aria-expanded={cartCollapse[cart]}>{cart}</h3>
                                        </div>
                                        <Collapse in={cartCollapse[cart]}>
                                            <div id={`collapse-${cart}-cart`}>
                                                {cartsList[cart].map((agentData, index) => (
                                                    <BuildCrackersList key={index} agentName={cartsList[cart][index].agent_name}
                                                        isMobileView={isMobileView}
                                                        cartName={cart}
                                                        crackers={cartsList[cart][index].crackers}
                                                        needRefresh={needRefresh}
                                                        setNeedRefresh={setNeedRefresh} />
                                                ))}
                                            </div>
                                        </Collapse>
                                        </div>
                                    </div>    
                                ))) : (
                                    <div className="ct-vw" style={{marginTop : "10vh", marginBottom : "10vh"}}>
                                        <h1>Crackers have not yet been added to your cart.</h1>
                                        <h3><a href="/web/crackers">Click here</a> to shop for crackers.</h3>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="ct-vw-cnt">
                            <Row>
                                {/* <div> */}
                                <Col lg={8}>
                                    {
                                        carts.length > 0 ? (
                                            carts.map((cart, index) => (
                                                <div className="ct-vw">
                                                    <div key={cart}>
                                                        <div>
                                                            <h3 className="ct-vw-ttle" onClick={() => toggleCartCollapse(cart)} aria-controls={`collapse-${cart}-cart`} aria-expanded={cartCollapse[cart]}>{cart}</h3>
                                                        </div>
                                                        <Collapse in={cartCollapse[cart]}>
                                                            <div id={`collapse-${cart}-cart`}>
                                                                {cartsList[cart].map((agentData, index) => (
                                                                    <BuildCrackersList key={index} agentName={cartsList[cart][index].agent_name}
                                                                        isMobileView={isMobileView}
                                                                        cartName={cart}
                                                                        crackers={cartsList[cart][index].crackers}
                                                                        needRefresh={needRefresh}
                                                                        setNeedRefresh={setNeedRefresh} />
                                                                ))}
                                                            </div>
                                                        </Collapse>
                                                    </div>
                                                </div>
                                        ))): 
                                        (
                                            <div className="ct-vw" style={{marginBottom : "50vh"}}>
                                                <div className="center_of_scrn_empt_ct">
                                                    <h1>Crackers have not yet been added to your cart.</h1>
                                                    <h3><a href="/web/crackers">Click here</a> to shop for crackers.</h3>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {/* </div> */}
                                </Col>
                                <Col lg={4}>
                                    {
                                        tAmount > 0 ? (
                                            <div style={{height : "auto", background : "lightgrey", borderRadius : "12px", marginTop : "8%"}}>
                                                <div style={{padding : "10%", display : "flex", flexDirection : "column", gap: "10px" }}>
                                                    <span style={{fontSize : "22px"}}>{`Total items: ${noOfItems}`}</span>
                                                    <span style={{fontSize : "22px"}}>{`Total quantities: ${noOfQtys}`}</span>
                                                    <span style={{fontSize : "22px"}}>{`Cart Value: ₹${cartsValue}`}</span>
                                                    <span style={{fontSize : "20px"}}>{`Parcel charges: ₹${parcelCharges}`}</span>
                                                    <span style={{fontSize : "20px"}}>{`Discount: ₹${discount}`}</span>
                                                    <span style={{fontSize : "20px"}}>{`Special Discount: ₹${splDiscount}`}</span>
                                                    <h5></h5>
                                                    <h3>{`Total Amount: ₹${tAmount - 200}`}</h3>
                                                    <div style={{display: "flex", justifyContent: "space-between", gap: "10px", marginTop: "20px"}}>
                                                        <Button className="ct-vw-cko-btn" variant="primary" style={{ cursor: 'pointer', width : "50%"}} onClick={(e) => navigate("/web/crackers")}>Continue Shopping</Button>
                                                        {
                                                            (isEligibleToCheckOut) ? (
                                                                <Button className="ct-vw-cko-btn" variant="warning" style={{ cursor: 'pointer', width : "50%"}} onClick={proceedToCheckOut}>
                                                                    Proceed to Buy
                                                                </Button>
                                                            ) : (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-top">
                                                                                Minimum order amount is ₹2300. Please add more items to proceed.
                                                                            </Tooltip>
                                                                        }>
                                                                        <span className="d-inline-block">
                                                                            <Button className="ct-vw-cko-btn" variant="warning" disabled style={{ pointerEvents: 'none' }}>Proceed to Buy</Button>
                                                                        </span>
                                                                    </OverlayTrigger>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    }
                                    
                                </Col>
                                {/* </div> */}
                            </Row>
                        </div>
                    </div>
                )
            }
        </div>
        
    );
}

function OrderPlaceCtrl({isMobileView, cartsValue, windowSize}) {
    const [loading, setLoading] = useState(false);
    const [isEligibleToCheckOut, setIsEligibleToCheckOut] = useState(false);
    const {setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);
    const navigate = useNavigate();
    var totalAmount = 0;
    if(cartsValue && cartsValue.length > 0) {
        for(let i=0; i<cartsValue.length; i++) {
            if(cartsValue[i].cart_value < cartsValue[i].min_order) {
                setIsEligibleToCheckOut(false);
                break;
            }
            totalAmount += cartsValue[i].cart_value;
        }
    } else {
        setIsEligibleToCheckOut(false);
    }

    const mobCheckOut = {
        marginTop: "10px",
        marginBottom: "20px",
        position: "sticky",
        top: isMdScreen(windowSize.width) ? "95px" : "118px",
        // color: "white",
        zIndex: "9"
    }

    const proceedToCheckOut = async () => {
        if(isEligibleToCheckOut) {
            const status = await raisePostRequest(`/carts/check-out`, null, setLoading, setShowErrorToastStatus, setToastBody);
            if(status && status.status === 'success') {
                // const cartAmount = status.cart_amount;
                navigate("/web/checkout");
            }
        }
    }

    return (
        (isMobileView) ?
        (
            <div style={mobCheckOut}>
                <Col xs={12} className="d-flex justify-content-end">
                    <div>
                        {/* <div>
                            <span>Your cart value is, <span className="ct-vw-cko-cst">₹ {totalAmount}</span></span>
                        </div> */}
                        <div>
                            <Button className="ct-vw-cko-btn" variant="primary" onClick={(e) => navigate("/web/crackers")}>Continue Shopping</Button>
                            {
                                (isEligibleToCheckOut) ? (
                                    <Button className="ct-vw-cko-btn" variant="warning" onClick={proceedToCheckOut}>
                                        {!loading && 'Check Out'}
                                        {loading && <LoadingBorder/>}
                                    </Button>
                                ) : (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    Minimum order amount is ₹2300. Please add more items to proceed.
                                                </Tooltip>
                                            }>
                                            <span className="d-inline-block">
                                                <Button className="ct-vw-cko-btn" variant="warning" disabled style={{ pointerEvents: 'none' }}>Check Out</Button>
                                            </span>
                                        </OverlayTrigger>
                                )
                            }
                        </div>
                    </div>
                </Col>
            </div>
        ): (
            <div className="ct-vw-cko">
                <Row>
                    <Col lg={9} style={{background : "transparent", zIndex : -2}}></Col>
                    <Col lg={3} style={{background : "transparent"}} className="d-flex flex-column justify-content-end">
                        {/* <span>Your cart value is, <span className="ct-vw-cko-cst">₹ {totalAmount}</span></span> */}
                        <div style={{ width: "100%", display: 'flex', flexDirection: 'row', marginTop: '10px', marginBottom: '20px', alignItems : 'end', marginRight : '3%' }}>
                            <span className="d-inline-block">
                                <Button className="ct-vw-cko-btn" variant="primary" onClick={(e) => navigate("/web/crackers")}>Continue Shopping</Button>
                            </span>
                            
                            {
                                (isEligibleToCheckOut) ? (
                                    <Button className="ct-vw-cko-btn" variant="warning" onClick={proceedToCheckOut}>
                                        {!loading && 'Check Out'}
                                        {loading && <LoadingBorder/>}
                                    </Button>
                                ) : (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    Minimum order amount is ₹2300. Please add more items to proceed.
                                                </Tooltip>
                                            }>
                                            <span className="d-inline-block">
                                                <Button className="ct-vw-cko-btn" variant="warning" disabled style={{ pointerEvents: 'none' }}>Check Out</Button>
                                            </span>
                                        </OverlayTrigger>
                                )
                            }
                            
                        </div>
                    </Col>
                </Row>
            </div>
        )
    );
}

function AgentEstimation({isMobileView, cartsValue, needRefresh, setNeedRefresh, setCartsAmount}) {
    return(
        (cartsValue.length === 0) ? (
            null
        ) : (
            <div style={{marginRight: isMobileView ? '0%' : '3%', width: isMobileView ? '103vw' : ''}}>
                <Row>
                    <Col xs={12} className="d-flex justify-content-end">
                        <table className="ct_vw_agnt_est">
                            <thead>
                                <tr className="ct_vw_agnt_est_tr">
                                    {/* <th className="ct_vw_agnt_est_td">Dealer</th> */}
                                    <th className="ct_vw_agnt_est_td">Min-Order</th>
                                    <th className="ct_vw_agnt_est_td">Carts Value</th>
                                    <th className="ct_vw_agnt_est_td"></th>
                                    <th className="ct_vw_agnt_est_td"></th>
                                    <th className="ct_vw_agnt_est_td"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    cartsValue.map((cartValue, index) => (
                                        <AgentEstimationRow key={index} 
                                                            agentId={cartValue.agent_id}
                                                            agentName={cartValue.agent_name}
                                                            minOrder={cartValue.min_order}
                                                            cartValue={cartValue.cart_value}
                                                            needRefresh={needRefresh}
                                                            setNeedRefresh={setNeedRefresh}
                                                            cartsAmount={cartsValue}
                                                            setCartsAmount={setCartsAmount}/>
                                ))}
                            </tbody>
                            
                        </table>
                    </Col>
                </Row>
            </div>
        )
        
    );
}

function AgentEstimationRow({agentId, agentName, minOrder, cartValue, needRefresh, setNeedRefresh, cartsAmount, setCartsAmount}) {
    const styleClass = "ct_vw_agnt_est_tr " + (cartValue >= minOrder  ? 'ct_vw_agnt_est_tr_s' : 'ct_vw_agnt_est_tr_ns');
    const [savePopup, setSavePopup] = useState(false);
    const [clearPopup, setClearPopup] = useState(false);
    const [currentAgentId, setCurrentAgentId] = useState(null);
    const {userInfo, setBrowserCart, setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);

    const handleSaveClick = (agentId) => {
        setCurrentAgentId(agentId);
        setSavePopup(true);
    }

    const closeSavePopup = () => {
        setCurrentAgentId(null);
        setSavePopup(false);
    }

    const saveCartItems = async () => {
        if(currentAgentId) {
            var data = {
                "agent_id" : agentId,
            }
            const response = await raisePostRequest(`/carts/items/save-fr-nxt-odr`, data, null, setShowErrorToastStatus, setToastBody);
            setCurrentAgentId(null);
            setSavePopup(false);
            setNeedRefresh(!needRefresh);
        } else {
            alert("smoething went worng save items");
        }
    }

    const handleClearClick = (agentId) => {
        setCurrentAgentId(agentId);
        setClearPopup(true);
    }

    const closeClearPopup = () => {
        setCurrentAgentId(null);
        setClearPopup(false);
    }

    const clearCartItems = async (cartsAmount, setCartsAmount, setNeedRefresh) => {
        if(currentAgentId) {
            const data = { 
                agent_id: agentId 
            }
            clearCartItemsUtil(userInfo, data, setBrowserCart, null, setShowErrorToastStatus, setToastBody);
            var tempCarts = cartsAmount;
            for(let i=0; i<tempCarts.length; i++) {
                if(tempCarts[i].agent_id === agentId) {
                    tempCarts[i].cart_value = 0;
                    tempCarts[i].quantity = 0;
                    setCartsAmount(tempCarts);
                }
            }

            setCurrentAgentId(null);
            setClearPopup(false);
            setNeedRefresh(!needRefresh);
        } else {
            alert("Something went wrong clear items");
        }
        
    }

    return(
        <tr className= {styleClass}>
            {/* <td className="ct_vw_agnt_est_td">{agentName}</td> */}
            <td className="ct_vw_agnt_est_td">{minOrder}</td>
            <td className="ct_vw_agnt_est_td">{cartValue}</td>
            <td className="ct_vw_agnt_est_td"><Button variant="light" as="a" href={`/web/crackers?filter=All&agent_id=${agentId}`} >Add more</Button></td>
            <td className="ct_vw_agnt_est_td"><Button variant="light" as="button" onClick={() => handleSaveClick(agentId)} disabled={userInfo && userInfo.authenticated ? false : true}>Save for Next Order</Button></td>
            <td className="ct_vw_agnt_est_td"><Button variant="light" as="button" onClick={() => handleClearClick(agentId)}>Clear</Button></td>
            <ConfirmPopUp show={savePopup}
                            handleClose={closeSavePopup}
                            handleConfirm={saveCartItems}
                            title={"Save confirm"}
                            message={`Are you sure to move items to save list?<br><b>Note: </b>It's automatically moved to cart for next trasaction else you can move yourself by Accounts page.`}
                            // message={`Are you sure to move items of <b>${agentName}</b> to save list?<br><b>Note: </b>It's automatically moved to cart for next trasaction else you can move yourself by Accounts page.`}
                            proceedCaption={"Yes"}
                            cancelCaption={"No"}/>
            
            <ConfirmPopUp show={clearPopup}
                            handleClose={closeClearPopup}
                            handleConfirm={() => clearCartItems(cartsAmount, setCartsAmount, setNeedRefresh)}
                            title={"Clear confirm"}
                            message={`Are you sure to clear items to save list?`}
                            // message={`Are you sure to clear items of <b>${agentName}</b> to save list?`}
                            proceedCaption={"Yes"}
                            cancelCaption={"No"}/>
        </tr>
    );
}

function BuildCrackersList({isMobileView, agentName, cartName, crackers, needRefresh, setNeedRefresh}) {
    return (
        (isMobileView) ? (
            <>
                {/* <h4>{agentName}</h4> */}
                <div className="ct-vw-crcks">
                    <Row>
                        {
                            crackers.map((cracker, index) => (
                                (cracker.order_quantity > 0) ? (
                                    <MobileScreenRow key={cracker.crackers_id}
                                        crackersId={cracker.crackers_id}
                                        imageLink={cracker.link}
                                        cartName={cartName}
                                        stockStatus={cracker.stock_status}
                                        crackersName={cracker.crackers_name}
                                        ppq={cracker.offer_price}
                                        oq={cracker.order_quantity}
                                        pr={cracker.order_price}
                                        needRefresh={needRefresh}
                                        setNeedRefresh={setNeedRefresh}
                                    />
                                ) : (
                                    null
                                )
                                
                            ))
                        }
                    </Row>
                </div>
            </>
        ) : (
            <>
                {/* <h4>{agentName}</h4> */}
                <div className="ct-vw-crcks">
                    <LgTableHeader/>
                    {
                        crackers.map((cracker, index) => (
                            (cracker.order_quantity > 0) ? (
                                <LgTableRow key={cracker.crackers_id}
                                    crackersId={cracker.crackers_id}
                                    imageLink={cracker.link}
                                    cartName={cartName}
                                    stockStatus={cracker.stock_status}
                                    crackersName={cracker.crackers_name}
                                    ppq={cracker.offer_price}
                                    oq={cracker.order_quantity}
                                    pr={cracker.order_price}
                                    needRefresh={needRefresh}
                                    setNeedRefresh={setNeedRefresh}
                                />
                            ) : (
                                null
                            )
                        ))
                    }
                </div>
            </>
        )
    )
}

function LgTableHeader() {
    return(
        <Row>
            <Col className="ct-vw-col-top-left text-center ct-vw-col-hd d-flex align-items-center" lg={1}>
            </Col>
            <Col className="ct-vw-col-top text-center ct-vw-col-hd d-flex align-items-center" lg={5}>
                <h6>Crackers Name</h6>
            </Col>
            <Col className="ct-vw-col-top text-center ct-vw-col-hd d-flex align-items-center" lg={1}>
                <h6>Price per Qty</h6>
            </Col>
            <Col className="ct-vw-col-top text-center ct-vw-col-hd d-flex align-items-center" lg={2}>
                <h6>Order Quantity</h6>
            </Col>
            <Col className="ct-vw-col-top text-center ct-vw-col-tp-hd ct-vw-col-hd d-flex align-items-center" lg={2}>
                <h6>Price</h6>
            </Col>
        </Row>
    );
}

function LgTableRow({crackersId, imageLink, cartName, stockStatus, crackersName, ppq, oq, pr, needRefresh, setNeedRefresh}) {
    const [loading, setLoading] = useState(false);
    const[prevQty, setPrevQty] = useState(oq);
    const[qty, setQty] = useState(oq);
    const oosStyle = stockStatus === 0 ? { filter: 'grayscale(100%)', textDecoration : 'line-through', color: 'grey', fontWeight: 'normal'} : {};
    const [itemRemovePopup, setItemRemovePopup] = useState(false);
    const [currentData, setCurrentData] = useState(null);
    const {setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart, userInfo } = useContext(CrackersContext);
    const timeoutRef = useRef(null);
    
    const handleItemRemovePopupClose = () => {
        setItemRemovePopup(false);
        setCurrentData(null);
    }

    const handleItemRemovePopup = (cartName, crackersId) => {
        setItemRemovePopup(true);
        setCurrentData({"cartName" : cartName, "crackersId" : crackersId});
    }

    const removeItem = async () => {
        if(currentData) {
            const response = await removeCrackersFromCart(userInfo, currentData.cartName, currentData.crackersId, browserCart, setBrowserCart, null, null, null);
            if(response.status === 'success') {
                setItemRemovePopup(false);
                setCurrentData(null);
                setPrevQty(null);
                setNeedRefresh(!needRefresh);
            } else {
                alert(response.message);
            }
            
        } else {
            alert("something went wrong remove item?");
        }
    }

    const beforeOrderQtyChange = (event) => {
        setPrevQty(Number(event.target.value));
    }
    
    const orderQtyChange = (event) => {
        const newQty = Number(event.target.value);
        if(newQty < 0) {
            event.target.value = 0;
            setQty(0);
            return;
        }
        setQty(newQty);
        debounceUpdateCart(crackersId, cartName, newQty, 2000);
    }

    const afterOrderQtyChanged = async (event, cartName) => {
        if(prevQty !== qty) {
            // const params = {
            //     "cart_name" : cartName,
            //     "quantity" : qty
            // }
            // await raisePostRequest(`/crackers/${crackersId}/add-cart`, params, setLoading, setShowErrorToastStatus, setToastBody);
            debounceUpdateCart(crackersId, cartName, qty, 500);
            // setPrevQty(qty);
            // setNeedRefresh(!needRefresh);
        }
        
    }

    const debounceUpdateCart = (crackersId, cartName, qty, waitTime) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setLoading(true);
        timeoutRef.current = setTimeout(() => {
            if(qty !== prevQty) {
                updateCart(crackersId, cartName, qty);
            }
            setLoading(false);    
        }, waitTime);
    };
    
    const updateCart = async (crackersId, cartName, qty) => {
        const params = {
            "cart_name": cartName,
            "quantity": qty
        }
        const response = await addCrackersIntoCart(userInfo, crackersId, params, null, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart);
        setPrevQty(qty);
        setNeedRefresh(!needRefresh);
    }

    return(
        (stockStatus === 0) ? (
            <Row>
                <Col className="ct-vw-col-left d-flex align-items-center text-center" lg={1}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                        <img className="ct-vw-tn" style={oosStyle} src={imageLink} alt="NA"></img>
                    </OverlayTrigger>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" lg={5}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                        <span className="ct-vw-crcks-name" style={oosStyle}>{crackersName}</span>
                    </OverlayTrigger>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" lg={1}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                        <span>{ppq}</span>
                    </OverlayTrigger>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center cl_ct" lg={2}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                        <Form.Control className="cl_cart_qnt" style={oosStyle} size="sm" type="number" value={qty} disabled={true}/>
                    </OverlayTrigger>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" style={{ width: "15%" }} lg={3}>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                        <span style={stockStatus === 0 ? oosStyle : { marginRight: "4%", fontWeight: "bold" }}>{pr}</span>
                    </OverlayTrigger>
                </Col>
                <Col className="d-flex align-items-center text-center" lg={1}>
                    <Button style={{ color: "red" }} className="ct-vw-delete-btn" variant="danger" as="button" onClick={() => handleItemRemovePopup(cartName, crackersId)}>X</Button>
                </Col>
                <ConfirmPopUp show={itemRemovePopup}
                            handleClose={handleItemRemovePopupClose}
                            handleConfirm={removeItem}
                            title={"Remove crackers"}
                            message={`Are you sure to remove Crackers?`}
                            proceedCaption={"Yes"}
                            cancelCaption={"No"}/>
            </Row>
        ) : (
            <Row >
                <Col className="ct-vw-col-left d-flex align-items-center text-center" lg={1}>
                    <img className="ct-vw-tn" style={oosStyle} src={imageLink} alt="NA"></img>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" lg={5}>
                    <span className="ct-vw-crcks-name" style={oosStyle}>{crackersName}</span>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" lg={1}>
                    <span>{ppq}</span>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center cl_ct" lg={2}>
                    <Form.Control className="cl_cart_qnt" style={oosStyle} size="sm" type="number" value={qty} 
                                        onFocus={(e) => beforeOrderQtyChange(e)}
                                        onKeyDown={(e) => {numericInputOnly(e)}} 
                                        onChange={(e) => orderQtyChange(e)} 
                                        onBlur={(e) => afterOrderQtyChanged(e, cartName)}/>
                </Col>
                <Col className="ct-vw-col d-flex align-items-center text-center" style={{ width: "15%"}} lg={3}>
                    {!loading && <span  style={stockStatus === 0 ? (oosStyle) : ({ marginRight: "4%", fontWeight: "bold" })}>{pr}</span>}
                    {loading && <LoadingSpinner />}
                </Col>
                <Col className="d-flex align-items-center text-center" lg={1}>
                    <Button style={{ color: "red" }} className="ct-vw-delete-btn" variant="danger" as="button" onClick={() => handleItemRemovePopup(cartName, crackersId)}>X</Button>
                </Col>
                <ConfirmPopUp show={itemRemovePopup}
                            handleClose={handleItemRemovePopupClose}
                            handleConfirm={removeItem}
                            title={"Remove crackers"}
                            message={`Are you sure to remove Crackers?`}
                            proceedCaption={"Yes"}
                            cancelCaption={"No"}/>
            </Row>
        )
    );
}

function  MobileScreenRow({crackersId, imageLink, cartName, stockStatus, crackersName, ppq, oq, pr, needRefresh, setNeedRefresh}) {
    const [loading, setLoading] = useState(false);
    const [prevQty, setPrevQty] = useState(oq);
    const [itemRemovePopup, setItemRemovePopup] = useState(false);
    const [currentData, setCurrentData] = useState(null);
    const [qty, setQty] = useState(oq);
    const qtyRef = useRef(null);
    const {setShowErrorToastStatus, setToastBody, userInfo, browserCart, setBrowserCart } = useContext(CrackersContext);
    const timeoutRef = useRef(null);
    const oosStyle = stockStatus === 0 ? {filter: 'grayscale(100%)'} : {};
    
    
    const handleItemRemovePopupClose = () => {
        setItemRemovePopup(false);
        setCurrentData(null);
    }

    const handleItemRemovePopup = (cartName, crackersId) => {
        setItemRemovePopup(true);
        setCurrentData({"cartName" : cartName, "crackersId" : crackersId});
    }

    const removeItem = async () => {
        if(currentData) {
            const response = await removeCrackersFromCart(userInfo, currentData.cartName, currentData.crackersId, browserCart, setBrowserCart, null, null, null);
            if(response.status === 'success') {
                setItemRemovePopup(false);
                setCurrentData(null);
                setPrevQty(null);
                setNeedRefresh(!needRefresh);
            } else {
                alert(response.message);
            }
        } else {
            alert("something went wrong remove item?");
        }
    }

    const orderQtyChange = (event) => {
        var currentValue = Number(event.target.value);
        if(currentValue < 1) {
            currentValue = 0;
        }
        setQty(currentValue);
        debounceUpdateCart(crackersId, cartName, currentValue);
    }

    const decrQty = () => {
        const currentValue = Math.max(Number(qtyRef.current.value) - 1, 0);
        setQty(currentValue);
        debounceUpdateCart(crackersId, cartName, currentValue);
    };

    const incrQty = () => {
        const currentValue = Number(qtyRef.current.value) + 1;
        setQty(currentValue);
        debounceUpdateCart(crackersId, cartName, currentValue);
    };

    const debounceUpdateCart = (crackersId, cartName, qty) => {
        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setLoading(true);
        timeoutRef.current = setTimeout(() => {
            if(qty !== prevQty) {
                updateCart(crackersId, cartName, qty);
            }
            setLoading(false);    
        }, 2000);
        
    };
    
    const updateCart = async (crackersId, cartName, qty) => {
        const params = {
            "cart_name": cartName,
            "quantity": qty
        }
        const response = await addCrackersIntoCart(userInfo, crackersId, params, null, setShowErrorToastStatus, setToastBody, browserCart, setBrowserCart);
        setPrevQty(qty);
        setNeedRefresh(!needRefresh);
    }


    return(
        (stockStatus === 0) ? (
            <>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Out of Stock</Tooltip>}>
                    <Col xs={12} sm={6} md={4}>
                        <div className="ct-vw-mob-tle">
                            <Button className="ct-vw-mob-delete-btn" style={{ color: "red", filter: "none" }} variant="danger" as="button" onClick={() => handleItemRemovePopup(cartName, crackersId)}>X</Button>
                            <div>
                                <div className="ct-vw-mob-tle-tilte" style={oosStyle}>
                                    <img className="ct-vw-mob-tn" src={imageLink} alt="Lakshmi Crackers" />
                                    <span className="ct-vw-mob-cr-nm">{crackersName}</span>
                                </div>
                                <span className="ct-vw-mob-pr-pq">Price/Quantity: ₹ <span>{ppq}</span></span>
                                <div className="cl_ct"  style={oosStyle}>
                                    <img className="cl_ct_qc" src={decr} alt="Decrease Quantity" />
                                    <Form.Control className="cl_cart_qnt" size="sm" type="text" placeholder={oq} readOnly={true} />
                                    <img className="cl_ct_qc" src={incr} alt="Increase Quantity" />
                                </div>
                                <span className="ct-vw-mob-pr-tg">Price: ₹ <span>{pr}</span></span>
                            </div>
                        </div>
                    </Col>
                </OverlayTrigger>

                <ConfirmPopUp
                    show={itemRemovePopup}
                    handleClose={handleItemRemovePopupClose}
                    handleConfirm={removeItem}
                    title={"Remove crackers"}
                    message={`Are you sure to remove Crackers?`}
                    proceedCaption={"Yes"}
                    cancelCaption={"No"}
                />
            </>
            
        ) : (
            <>
                <Col xs={12} sm={6} md={4}>
                    <div className="ct-vw-mob-tle">
                        <Button className="ct-vw-mob-delete-btn" style={{ color: "red", filter: "none" }} variant="danger" onClick={() => handleItemRemovePopup(cartName, crackersId)}>X</Button>
                        <div style={oosStyle}>
                            <div className="ct-vw-mob-tle-tilte">
                                <img className="ct-vw-mob-tn" src={imageLink} alt="Lakshmi Crackers" />
                                <span className="ct-vw-mob-cr-nm">{crackersName}</span>
                            </div>
                            <span className="ct-vw-mob-pr-pq">Price/Quantity: ₹ <span>{ppq}</span></span>
                            <div className="cl_ct" lg={3}>
                                <img className="cl_ct_qc" src={decr} alt="Decrease Quantity" onClick={decrQty} />
                                <Form.Control className="cl_cart_qnt" size="sm" type="text" ref={qtyRef} value={qty} onChange={(e) => {orderQtyChange(e)}} onKeyDown={(e) => {numericInputOnly(e)}}/>
                                <img className="cl_ct_qc" src={incr} alt="Increase Quantity" onClick={incrQty}/>
                            </div>
                            {!loading && <span className="ct-vw-mob-pr-tg">Price: ₹ <span>{pr}</span></span>}
                            {loading && <LoadingSpinner size={'20px'}/>}
                        </div>
                    </div>
                </Col>
                <ConfirmPopUp show={itemRemovePopup}
                handleClose={handleItemRemovePopupClose}
                handleConfirm={removeItem}
                title={"Remove crackers"}
                message={`Are you sure to remove Crackers?`}
                proceedCaption={"Yes"}
                cancelCaption={"No"}/>
            </>
        )
        
    );
}

export default CartView;